<app-banner-app [retroSelected]="true" [Parametros]="this.parametro" [PaginaAnterior]="'PlanesSeguros'"
    [IdentLead]="this.leadId" [codAsesor]="this.codAsesor" [bitacoraId]="this.IdBitacora"></app-banner-app>
<br><br>

<!-- Stepper -->
<div class="visibilidadDiv">
    <div class="container" style="width: 700px;">
        <div class="row">
            <div class="col">
                <br><br><br><br>
                <div id="stepper1" class="bs-stepper">
                    <div class="bs-stepper-header" style="text-align: center;">
                        <div class="step" data-target="#test-l-1">
                            <div>
                                <span class="bs-stepper-circle estiloTextoNum" style="background-color: #00AEC7;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-check-lg" viewBox="0 0 16 16">
                                        <path
                                            d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                    </svg>
                                </span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Arriendo</span>
                            </div>
                        </div>
                        <div class="line" style="background-color: #2D6DF6; height: 2px;  margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-2">
                            <div>
                                <span class="bs-stepper-circle estiloTextoNum" style="background-color: #00AEC7;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-check-lg" viewBox="0 0 16 16">
                                        <path
                                            d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                    </svg>
                                </span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Planes</span>
                            </div>
                        </div>
                        <div class="line" style="background-color: #2D6DF6; height: 2px;  margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-3">
                            <div>
                                <span class="standby bs-stepper-circle estiloTextoNum"
                                    style="background-color: #2D6DF6;">3</span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Datos propietario</span>
                            </div>
                        </div>
                        <div class="line" style="height: 2px;  margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-3">
                            <div>
                                <span class="standby bs-stepper-circle estiloTextoNum">4</span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Inmueble</span>
                            </div>
                        </div>
                        <div class="line" style="height: 2px;  margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-3">
                            <div>
                                <span class="standby bs-stepper-circle estiloTextoNum">5</span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Datos inquilino</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
</div>

<!-- Progress Bar -->
<div class="container contenedorProgressBar">
    <br><br>
    <div class="row">
        <div class="col">
            <strong>
                <p class="progressBarActivo">Datos del propietario</p>
            </strong>
        </div>
        <div class="col">
            <strong>
                <p class="progressBarInactivo">Siguiente: Inmueble</p>
            </strong>
        </div>
    </div>
    <ngb-progressbar class="mb-3" type="primary" [value]="50" height=".5rem">
    </ngb-progressbar>
</div>


<div class="estiloFranjaPlan">
    <div class="Franja">
        <div class="textoElegistes">
            Elegiste
        </div>
        <div class="textoPlan" style="width: 200px;">
            {{ planSeleccionado === 'Arma tu plan' ? 'Arma tu plan' : 'Plan ' + planSeleccionado }}
        </div>
    </div>
    <div class="textoArriba">
        <img src="./assets/img/Casita.png" class="casita" />
    </div>
</div>

<br><br><br>

<div class="container">
    <div class="row">
        <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0">
            <div class="textoArriba" style="margin-left: 80px;">
                <div class="aliniacionTexto">
                    <br>
                    <p class="texto2">Completa los datos del propietario</p>
                    <p class="texto1">para visualizar el<br> inmueble a asegurar</p>
                </div>
                <div class="aliniacionImagen">
                    <img class="styleImage img-responsive" src="./assets/img/Apartamento.png" />
                </div>
            </div>
            <div class="textoAbajo">
                <div class="aliniacionTextoMobile">
                    <p class="texto1">Completa los datos del propietario</p>
                    <p class="texto2">para visualizar el inmueble a asegurar</p>
                </div>
            </div>
        </div>
        <br>
        <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0">
            <main class="form-signin w-100 m-auto">
                <form [formGroup]="formulario">
                    <label for="primerNombre" style="color: #3F3F41;" class="tipoLetra">*Primer nombre</label>

                    <input type="text" #primerNombre required class="form-control tipoLetra estiloPrincipal"
                        style="color: #B4B4B5; height: 48px;" formControlName="primerNombre" id="primerNombre"
                        placeholder="Escribe tu primer nombre" [ngModel]="datosGenerales.Cliente.nombreCliente"
                        [ngClass]="{ valPrimerNombre2: valPrimerNombre2, valPrimerNombre: valPrimerNombre }"
                        (focusout)="validacionPrimerNombre()" style="color: #000; height: 48px;"
                        onkeydown="return /[a-z, ñÑ, íÍ, óÓ, áÁ, éÉ, úÚ]/i.test(event.key)">
                    <small *ngIf="primerNombreNoValido" class="text-danger tipoLetra">Escribe tu primer nombre</small>
                    <br>

                    <label for="segundoNombre" style="color: #3F3F41;" class="tipoLetra">Segundo nombre</label>

                    <input type="text" #segundoNombre class="form-control tipoLetra estiloPrincipal"
                        formControlName="segundoNombre" id="segundoNombre" placeholder="Escribe tu segundo nombre"
                        style="color: #B4B4B5; height: 48px; border: solid 1px #B4B4B5;"
                        style="color: #000; height: 48px;"
                        onkeydown="return /[a-z, ñÑ, íÍ, óÓ, áÁ, éÉ, úÚ]/i.test(event.key)">
                    <br>

                    <label for="primerApellido" style="color: #3F3F41;" class="tipoLetra">*Primer apellido</label>
                    <input type="text" #primerApellido required class="form-control tipoLetra estiloPrincipal"
                        formControlName="primerApellido" id="primerApellido" style="color: #B4B4B5; height: 48px;"
                        placeholder="Escribe tu primer apellido"
                        [ngClass]="{ valPrimerApellido2: valPrimerApellido2, valPrimerApellido: valPrimerApellido }"
                        (focusout)="validacionPrimerApellido()" style="color: #000; height: 48px;"
                        onkeydown="return /[a-z, ñÑ, íÍ, óÓ, áÁ, éÉ, úÚ]/i.test(event.key)">
                    <small *ngIf="primerApellidoNoValido" class="text-danger tipoLetra">Escribe tu primer
                        apellido</small>
                    <br>

                    <label for="segundoApellido" style="color: #3F3F41;" class="tipoLetra">Segundo apellido</label>

                    <input type="text" #segundoApellido class="form-control tipoLetra estiloPrincipal"
                        style="color: #B4B4B5; height: 48px; border: solid 1px #B4B4B5;"
                        style="color: #000; height: 48px;" formControlName="segundoApellido" id="segundoApellido"
                        placeholder="Escribe tu segundo apellido"
                        onkeydown="return /[a-z, ñÑ, íÍ, óÓ, áÁ, éÉ, úÚ]/i.test(event.key)">
                    <br>

                    <label for="paisNacimento" style="color: #3F3F41;" class="tipoLetra">*Pa&iacute;s de
                        nacimiento</label>

                    <input type="text" #paisNacimiento required class="form-control tipoLetra estiloPrincipal"
                        style="color: #B4B4B5; height: 48px;border: solid 1px #B4B4B5;" formControlName="paisNacimiento"
                        id="paisNacimiento" name="paisNacimiento" [value]="this.paisDefecto" readonly
                        [ngClass]="{ valPaisNacimento2: valPaisNacimento2, valPaisNacimento: valPaisNacimento }"
                        (focusout)="validacionPaisNacimento()" style="color: #000; height: 48px;">
                    <small *ngIf="paisNacimientoNoValido" class="text-danger tipoLetra">Selecciona el país de
                        nacimiento</small>
                    <br>

                    <label for="tipoIdentificacion" style="color: #3F3F41;" class="tipoLetra">*Tipo de
                        Identificacion</label>

                    <select name="tipoIdentificacion" required id="tipoIdentificacion" #tipoIdentificacion
                        formControlName="tipoIdentificacion" class="form-control tipoLetra estiloPrincipal"
                        style="color: #000; height: 48px;" [value]="selectTipoIdentificacion"
                        [ngClass]="{ valTipoidentificacion2: valTipoidentificacion2, valTipoidentificacion: valTipoidentificacion }"
                        (focusout)="validacionTipoidentificacion()">
                        <option value="C">Cédula de ciudadanía</option>
                        <!-- <option value="E">Cédula de extranjería</option>
                        <option value="P">Pasaporte</option>
                        <option value="T">Tarjeta de identidad</option>
                        <option value="R">Registro civil</option> -->
                    </select>

                    <small *ngIf="tipoidentificacionNoValido" class="text-danger tipoLetra">Seleccione el tipo de
                        identificación</small>
                    <br>

                    <label for="documentoIdentidad" style="color: #3F3F41;" class="tipoLetra">*Número de
                        documento</label>

                    <input type="number" class="form-control tipoLetra estiloPrincipal" #documentoIdentidad
                        formControlName="documentoIdentidad" name="documentoIdentidad" id="documentoIdentidad"
                        placeholder="Digíta el número sin puntos" required style="color: #000; height: 48px;"
                        [ngClass]="{ valDocumentoIdentidad2: valDocumentoIdentidad2, valDocumentoIdentidad: valDocumentoIdentidad }"
                        (focusout)="validacionDocumentoIdentidad()" (wheel)="$event.preventDefault()">

                    <small *ngIf="documentoNoValido" class="text-danger tipoLetra">Asegúrate de incluir solo números y
                        que tengan entre 7 y 10 dígitos</small>
                    <br>


                    <label for="fechaExpedicion" style="color: #3F3F41;" class="tipoLetra">*Fecha expedición
                        documento</label>
                    <input type="date" style="color: #B4B4B5; height: 48px;"
                        class="form-control tipoLetra estiloPrincipal" placeholder="AAAA/MM/DD" name="fechaExpedicion"
                        id="fechaExpedicion" formControlName="fechaExpedicion" required
                        style="color: #000; height: 48px;"
                        [ngClass]="{ valFechaExpedicion2: valFechaExpedicion2, valFechaExpedicion: valFechaExpedicion }"
                        (focusout)="validacionFechaExpedicion()">

                    <small *ngIf="fechaExpedicionNoValido" class="text-danger tipoLetra">Debe seleccionar una fecha
                        de expedición valida</small>
                    <br>


                    <label for="correo" style="color: #3F3F41;" class="tipoLetra">*Correo electrónico</label>

                    <input type="text" class="form-control tipoLetra estiloPrincipal" #correo formControlName="correo"
                        id="correo" placeholder="usuario@correo.com" required style="color: #000; height: 48px;"
                        [ngClass]="{ valCorreo2: valCorreo2, valCorreo: valCorreo }" (focusout)="validacionCorreo()">
                    <small *ngIf="correoNoValido" class="text-danger tipoLetra">Escribe un correo valido</small>
                    <br>

                    <p class="camposObligatorios">*Los campos son obligatorios</p>
                    <br>

                    <div class="estiloBoton">
                        <button class="btn btn-primary w-100 py-2 botonContinuar" [disabled]="formularioNoValido"
                            (click)="Continuar()">
                            Continuar
                        </button>
                    </div>
                    <br><br>

                </form>
            </main>
        </div>
    </div>
</div>

<app-footer-app />